import React from 'react';

import BgSection from '../../i/bg_section_6.jpg';

const HowStreamInWorks = () => {
  return (
    <section className="section info_mod double_decor_mod center_level_mod offset_mod">
      <div className="section_bg loaded_mod" style={{ backgroundImage: `url(${BgSection})` }} />
      <div className="section_in">
        <div className="section_block center_level_mod limit_v1_mod">
          <h2 className="section_title offset_mod">HOW STREAM ME IN WORKS</h2>
          <div className="section_descr offset_mod darken_mod">With the StreaMeIn App you can connect and watch live stream performances, exclusive interviews, live Q&amp;A’s, and more with fans around the world. Stream a free show to fans or a paid exclusive event.</div><a className="btn_base" href="#">Learn More</a>
        </div>
      </div>
    </section>
  );
}
export default HowStreamInWorks;